












































import Vue from 'vue'
import { storehelper } from '@/store'
import { KeyDict } from '@/types'
import { Subscription } from '@/store/types'
import BotsManager from '@/components/BotsManager'
import Modal from '@/components/Modal'

export default Vue.extend({
  name: 'SnapShotCounter',
  computed: {
    openSubscriptions (): KeyDict<Subscription> {
      return storehelper.subscriptions
    }
  },
  data: () => ({
    show: false
  }),
  methods: {
    open () {
      console.log("OPEN")
      this.show = true
    }
  },
  components: {
    Modal,
    BotsManager
  }
})
